/**
 * @generated SignedSource<<739f9c9d472de5d3620eb6698a861645>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrderEnum = "ASC" | "DESC";
export type PostAccessRecipientSearchFieldsEnum = "AuthorId" | "Created" | "Domain" | "Email" | "ExpiresAt" | "Id" | "Modified" | "PostId" | "Status" | "Type";
export type PostAccessRecipientStatusEnum = "ACTIVE" | "EXPIRED" | "REVOKED";
export type PostObjectsConnectionDateColumnEnum = "DATE" | "MODIFIED";
export type RelationEnum = "AND" | "OR";
export type RootQueryToPostAccessRecipientConnectionWhereArgs = {
  authorId?: string | null | undefined;
  authorIdIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  authorIdNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  createdDateQuery?: DateQueryInput | null | undefined;
  domain?: string | null | undefined;
  email?: string | null | undefined;
  expiresAtDateQuery?: DateQueryInput | null | undefined;
  id?: string | null | undefined;
  idIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  idNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  modifiedDateQuery?: DateQueryInput | null | undefined;
  order?: OrderEnum | null | undefined;
  orderBy?: ReadonlyArray<PostAccessRecipientSearchFieldsEnum | null | undefined> | null | undefined;
  postId?: string | null | undefined;
  postIdIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  postIdNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  search?: string | null | undefined;
  searchFields?: ReadonlyArray<PostAccessRecipientSearchFieldsEnum | null | undefined> | null | undefined;
  status?: PostAccessRecipientStatusEnum | null | undefined;
  statusIn?: ReadonlyArray<PostAccessRecipientStatusEnum | null | undefined> | null | undefined;
  statusNotIn?: ReadonlyArray<PostAccessRecipientStatusEnum | null | undefined> | null | undefined;
  type?: string | null | undefined;
};
export type DateQueryInput = {
  after?: DateInput | null | undefined;
  before?: DateInput | null | undefined;
  column?: PostObjectsConnectionDateColumnEnum | null | undefined;
  compare?: string | null | undefined;
  day?: number | null | undefined;
  hour?: number | null | undefined;
  inclusive?: boolean | null | undefined;
  minute?: number | null | undefined;
  month?: number | null | undefined;
  relation?: RelationEnum | null | undefined;
  second?: number | null | undefined;
  week?: number | null | undefined;
  year?: number | null | undefined;
};
export type DateInput = {
  day?: number | null | undefined;
  month?: number | null | undefined;
  year?: number | null | undefined;
};
export type PostAccess_Recipients_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  where?: RootQueryToPostAccessRecipientConnectionWhereArgs | null | undefined;
};
export type PostAccess_Recipients_Query$data = {
  readonly postAccessRecipients: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly created: string | null | undefined;
        readonly domain: string;
        readonly email: string;
        readonly expiresAt: string | null | undefined;
        readonly id: string;
        readonly modified: string | null | undefined;
        readonly status: PostAccessRecipientStatusEnum;
      };
    }>;
  } | null | undefined;
};
export type PostAccess_Recipients_Query = {
  response: PostAccess_Recipients_Query$data;
  variables: PostAccess_Recipients_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "where"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "RootQueryToPostAccessRecipientConnection",
    "kind": "LinkedField",
    "name": "postAccessRecipients",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RootQueryToPostAccessRecipientConnectionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PostAccessRecipient",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "domain",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expiresAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "modified",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PostAccess_Recipients_Query",
    "selections": (v3/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PostAccess_Recipients_Query",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "4ccca522989480f9e9e2f09bddc5482c",
    "id": null,
    "metadata": {},
    "name": "PostAccess_Recipients_Query",
    "operationKind": "query",
    "text": "query PostAccess_Recipients_Query(\n  $first: Int\n  $after: String\n  $where: RootQueryToPostAccessRecipientConnectionWhereArgs\n) {\n  postAccessRecipients(first: $first, after: $after, where: $where) {\n    edges {\n      node {\n        id\n        email\n        domain\n        status\n        expiresAt\n        created\n        modified\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "37f6d161ee6a2b33765330d6b49fe9d1";

export default node;
